var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2M12 22V2M4.46154 18.5692C5.58882 17.883 6.52058 16.9182 7.16722 15.7677C7.81386 14.6172 8.15363 13.3197 8.15385 12C8.15363 10.6803 7.81386 9.38275 7.16722 8.23228C6.52058 7.0818 5.58882 6.11704 4.46154 5.43077M19.5385 5.43077C18.4116 6.1173 17.4802 7.08217 16.834 8.23263C16.1877 9.38309 15.8483 10.6805 15.8483 12C15.8483 13.3195 16.1877 14.6169 16.834 15.7674C17.4802 16.9178 18.4116 17.8827 19.5385 18.5692",
    stroke: "#3545DE",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBall);
export default __webpack_public_path__ + "static/media/ball.20fb95160bf81495e131d543d6f4def6.svg";
export { ForwardRef as ReactComponent };